import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import '@/styles/element-variables.scss'
import '@/styles/index.scss' // global css
import '@/icons/css/icons.css'
import '@/styles/swiper.min.css'

import App from '@/App'
import store from './store'
import router from './router'
import { request, port} from './utils/request'

import checkPermission from './utils/permission'

import '@/icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters


Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

Vue.use( CKEditor )

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

Vue.prototype.request = request
Vue.prototype.port = port

Vue.prototype.checkPermission = checkPermission

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

